var React = require('react');

function CreatorLockInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#42C296","d":"M70 37.5h-3.3333V25C66.6667 11.2122 54.707 0 40 0 25.293 0 13.3333 11.2122 13.3333 25v12.5H10c-5.51107 0-10 4.2038-10 9.375v43.75C0 95.7962 4.48893 100 10 100h60c5.5111 0 10-4.2038 10-9.375v-43.75c0-5.1712-4.4889-9.375-10-9.375zM22.2225 25c0-9.1919 7.9728-16.66641 17.7775-16.66641S57.7775 15.8081 57.7775 25v12.5h-35.555V25z"}));
}

CreatorLockInline.defaultProps = {"fill":"none","viewBox":"0 0 80 100"};

module.exports = CreatorLockInline;

CreatorLockInline.default = CreatorLockInline;
